import React, { createContext, useContext, useEffect, useState } from "react";

const KEY = "luxe_age_verified_v1";
const AgeGateContext = createContext(null);

export function AgeGateProvider({ children, onConfirm }) {
  const [verified, setVerified] = useState(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(KEY) === "1";
  });

  useEffect(() => {
    if (verified) localStorage.setItem(KEY, "1");
  }, [verified]);

  const confirm = () => {
    setVerified(true);
    if (typeof onConfirm === "function") onConfirm();
  };
  const deny = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AgeGateContext.Provider value={{ verified, confirm, deny }}>
      {children}
    </AgeGateContext.Provider>
  );
}

export const useAgeGate = () => useContext(AgeGateContext);
